export default __webpack_public_path__ + "static/media/G_D_btn__Redazione.61791c15.svg";